<script>

import MainComplaintForm from "./MainComplaintForm.svelte";
import { Circle3 } from "svelte-loading-spinners";

export let currentRoute;

let id = currentRoute.namedParams.id

</script>

<style>
  .themed {
    --borderRadius: 0px;
    --height: 50px;
    --border: 1px solid #dae1e3;
    --inputFontSize: 16px;
    --borderFocusColor: #80bdff;
    --placeholderColor: #a9a9a9;
    --listBorderRadius: 0px;
  }
</style>

<section id="denuncia" class="section mx-5">
  <div class="container">

    <h1 class="text-center">Registro exitoso</h1>
    <h2 class="text-center">Su <span style="color:red;">"número de caso"</span> es:</h2>
    <h1 style="margin-top: 50px;" class="text-center display-1 mb-4 font-weight-bold">{id}</h1>
    <h3 style="margin-top: 100px;" class="text-center ">Importante:</h3>

    <h5 class="mt-5 text-justify">Si registró un correo electrónico podrá hacer seguimiento de su(s) caso(s) y comunicarse vía chat con el Abogado que le fue asignado iniciando sesión con su <span style="color:red;">email</span> y <span style="color:red;">contraseña</span> en el siguiente enlace:</h5>

    <div class="text-center"><a class="btn text-center mt-3 mb-3" href="/login">Login</a></div>

    <h5 class="text-justify mt-3">Si no registró un correo electrónico podrá consultar el estado de su caso y comunicarse vía chat con el Abogado que le fue asignado, proporcionando su <span style="color:red;">número de caso</span> y <span style="color:red;">contraseña</span> en el siguiente enlace:</h5>

    <div class="text-center"><a class="btn text-center mt-3 mb-3" href="/estado-denuncia">Consultar estado</a></div>

    <h5 class="text-justify mt-3">Por favor consulte con frecuencia el estado de su caso, por si requerimos información adicional. ¡Gracias!</h5>

  </div>
</section>